import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import AddToCart from './AddToCart';

export default function FeaturedProduct({ data }) {
  const productData = useStaticQuery(productQuery);
  const matched = productData.allShopifyProduct.edges.find((element) => {
    return element.node.shopifyId === `gid://shopify/Product/${data.productId}`;
  })

  return (
    !matched ? (
      null
    ) : (
      <section className="FeaturedProduct hds-container hds-text-color pt-8">
        <div className="md:flex font-a1">
          <div className="w-full md:w-1/2 text-center">
            <div className="max-w-xs m-auto">
              <Image
                class="object-cover object-center h-full w-full"
                image={getImage(matched.node.images[0])}
                alt={""}
              />
            </div>
            <h4 className="font-heading text-tickProGreen font-bold">
              {matched.node.title}
            </h4>
            <p className="text-lg">${matched.node.priceRangeV2.maxVariantPrice.amount}</p>
            <AddToCart
              product={matched.node}
              variant={matched.node.variants[0]}
              quantity={1}
              classNames={`add-to-cart featured-product-btn ${!matched.node.variants[0].availableForSale && "fg-btn__disabled"}`}
              disabled={!matched.node.variants[0].availableForSale}
              buttonText="BUY NOW"
            />
            <p className="featured-product-gray font-heading">See Where to Buy tab to purchase larger quantities.</p>
          </div>
          <div className="w-full md:w-1/2">
            <div className="mt-8">
              {data.FCopy.value.document.children.map((copyBlock, i) => (
                copyBlock.type === "list" ? (
                  <ul key={`${copyBlock.type}${i}`}>
                    {copyBlock.children.map((listItem, i) => (
                      <li className="list-disc my-3 list-inside" key={`${listItem.type}${i}`}>
                        {listItem.children[0].children[0].value}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="mb-10 text-lg">
                    {copyBlock.children[0].value}
                  </p>
                )
              ))}
            </div>
          </div>
        </div>
      </section>
    )
  )
}

const productQuery = graphql`
query {
  allShopifyProduct {
    edges {
      node {
        ...ProductFragment
      }
    }
  }
}
`
